import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.a `
  position: relative;
  display: block;
  text-decoration: none;

  @media ${until(Device.Tablet)} {
    margin: 10px 20px 10px 5px;
  }
`;
const ImageContainer = styled.div `
  ${imageWrapperPreserveRatio(418, 325)};
  width: 100%;
  position: relative;
`;
const Image = styled.img `
  ${imageCoverContainer()};
  width: 100%;
  border-radius: 5px;
`;
const TagContainer = styled.div `
  position: absolute;
  left: 0;
  bottom: 0;
  height: 40px;
  background-color: ${brand.primary.blue.base};
  border: ${fluid(1, 2)} solid ${brand.white};
  border-bottom: 0;
  border-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0px 20px 0px 5px;
`;
const TagText = styled.div `
  ${fonts.inter.extraBold};

  font-size: 12px;
  line-height: 24px;
  color: ${brand.white};
  padding: 10px 40px 10px 25px;
`;
const ContentContainer = styled.div `
  padding-top: 24px;
`;
const Date = styled.div `
  ${fonts.sofiaPro.regular};
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
  color: ${brand.black};
`;
const Title = styled.p `
  ${fonts.inter.extraBold};

  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
  color: ${brand.black};
`;
const ReadMore = styled.p `
  ${fonts.sofiaPro.medium};
  font-size: 18px;
  line-height: 24px;
  color: ${brand.black};
  text-decoration: none;
`;
export const NewsCardStyles = {
    Container,
    ImageContainer,
    Image,
    ContentContainer,
    Date,
    Title,
    ReadMore,
    TagContainer,
    TagText,
};
